import styled from "styled-components";
import { DayStatus } from "../../../types";
import { RoundedIcon } from "../../rounded-icon/rounded-icon";
import React from "react";
import calendarService from "../../../services/calendar-service";
import {
  setBackgroundColorIcon,
  setTextColorIcon,
} from "../../../helpers/set-color";

interface DayProps {
  status: string;
  isSelected: boolean;
  day: moment.Moment;
  lastBookingDate: moment.Moment;
}

interface IStyle {
  today: boolean;
}

const CustomDay = styled.div<IStyle>`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => props.theme.primaryColor}30;
  text-decoration: ${(props) => (props.today ? "underline" : "none")};
  text-decoration-color: ${(props) => props.theme.primaryColor};
  border-radius: 50%;
  &:hover,
  &.isSelected {
    color: ${(props) => props.theme.invertFontColor};
    background-color: ${(props) => props.theme.primaryColor};
    text-decoration-color: ${(props) => props.theme.invertFontColor};
  }
`;

const DayOutOfDate = styled(CustomDay)`
  opacity: 0.4;
  background-color: transparent;
  pointer-events: none;
  &,
  &:hover {
    color: ${(props) => props.theme.legendBorderGray};
  }
`;

const DayFullStyle = styled(DayOutOfDate)<IStyle>`
  border: 1px dashed ${(props) => props.theme.legendBorderGray};
`;

const DayClosedStyle = styled(DayOutOfDate)<IStyle>`
  border: 1px solid ${(props) => props.theme.legendBorderGray};
`;

const DayUnavailable = styled(CustomDay)`
  background-color: ${(props) => props.theme.primaryColor}10;
`;

const Day = ({ status, isSelected, day, lastBookingDate }: DayProps) => {
  const today = calendarService.DATE_NOW;
  const isToday = day.isSame(today, "day");
  const isInThePast = day.diff(today) < 0;

  if (isInThePast) {
    return <DayOutOfDate today={false}>{day.format("D")}</DayOutOfDate>;
  } else {
    switch (status) {
      case DayStatus.waiting:
        return (
          <CustomDay
            data-test="day-available"
            today={isToday}
            className={isSelected ? "isSelected" : ""}
          >
            {day.format("D")}
            <RoundedIcon icon="waiting" position="right" />
          </CustomDay>
        );

      case DayStatus.full:
        return <DayFullStyle today={isToday}>{day.format("D")}</DayFullStyle>;

      case DayStatus.closed:
        return (
          <DayClosedStyle today={isToday}>{day.format("D")}</DayClosedStyle>
        );

      case DayStatus.available:
        return (
          <CustomDay
            today={isToday}
            className={isSelected ? "isSelected" : ""}
            data-test="day-available"
          >
            {day.format("D")}
          </CustomDay>
        );

      default:
        return (
          <DayUnavailable today={isToday} data-test="day-unavailable">
            {day.format("D")}
          </DayUnavailable>
        );
    }
  }
};
export default Day;
